import { LIGHT, RADIUS } from "../../shared/theme.js";
import { safeText } from "../../shared/formatters.js";
import { flattenNav, PERFIL_NAV } from "../../shared/navConfig.js";
import { useClientContext } from "../../ClientContext.jsx";
import type { Dispatch, SetStateAction } from "react";

interface LayoutHeaderProps {
  isMobile: boolean;
  clientNameProp?: string;
  _mobileOpen: boolean;
  setMobileOpen: Dispatch<SetStateAction<boolean>>;
}

export default function LayoutHeader({
  isMobile,
  clientNameProp,
  _mobileOpen,
  setMobileOpen,
}: LayoutHeaderProps) {
  const ctx = useClientContext();
  const T = ctx.T;

  const ctxAny = ctx as any;
  const client = (ctxAny.client ?? {}) as Record<string, unknown>;
  const snapshotData = ctxAny.snapshotData as Record<string, unknown> | null;
  const page = ctxAny.page as string | undefined;

  return (
    <>
      {/* Mobile header com hamburguer */}
      {isMobile && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 14,
            padding: "10px 4px",
          }}
        >
          <button
            onClick={() => setMobileOpen((o) => !o)}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 6,
              borderRadius: RADIUS.sm,
              color: T.text,
            }}
          >
            <div
              style={{
                width: 22,
                height: 2,
                background: T.text,
                marginBottom: 5,
                borderRadius: RADIUS.sm,
              }}
            />
            <div
              style={{
                width: 22,
                height: 2,
                background: T.text,
                marginBottom: 5,
                borderRadius: RADIUS.sm,
              }}
            />
            <div style={{ width: 16, height: 2, background: T.text, borderRadius: RADIUS.sm }} />
          </button>
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: RADIUS.sm,
              background: T.gold,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 900,
              color: T.text,
              fontSize: 14,
            }}
          >
            L
          </div>
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: RADIUS.full,
              background: `linear-gradient(135deg,${T.accent} 0%,${T.accentHover} 100%)`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: T.gold,
              fontWeight: 800,
              fontSize: 12,
            }}
          >
            {safeText(
              ((client.shortName as string) || (client.name as string) || "?")
                .slice(0, 2)
                .toUpperCase(),
              "mobile-avatar"
            )}
          </div>
        </div>
      )}

      {/* Desktop header */}
      <div
        className="no-print"
        style={{
          display: isMobile ? "none" : "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 800, color: T.text, margin: 0 }}>
            {safeText(
              [...flattenNav(), PERFIL_NAV].find((n) => n.id === page)?.label || "Dashboard",
              "page-label"
            )}
          </h1>
          <p style={{ fontSize: 11, color: T.muted, margin: "2px 0 0" }}>
            {safeText(client.name as string, "client.name")} ·{" "}
            {safeText(client.code as string, "client.code")}
            {snapshotData?.ref_date && typeof snapshotData.ref_date === "string"
              ? ` · Ref. ${new Date(snapshotData.ref_date as string).toLocaleDateString("pt-BR")}`
              : (client.lastUpdate as string) && (client.lastUpdate as string) !== "–"
                ? ` · Ref. ${safeText(client.lastUpdate as string, "client.lastUpdate")}`
                : ""}
          </p>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: T.text }}>
              Olá,{" "}
              {safeText(
                ((client.shortName as string) ||
                  (client.name as string) ||
                  clientNameProp ||
                  "Cliente") as string,
                "greeting-name"
              )}
            </div>
            <div style={{ fontSize: 11, color: T.muted }}>
              Perfil: {safeText(client.profile as string, "client.profile")}
            </div>
          </div>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: RADIUS.full,
              background: `linear-gradient(135deg,${T.accent} 0%,${T.accentHover} 100%)`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: T.gold,
              fontWeight: 800,
              fontSize: 13,
            }}
          >
            {safeText(
              (((client.shortName as string) || (client.name as string) || "?") as string)
                .slice(0, 2)
                .toUpperCase(),
              "desktop-avatar"
            )}
          </div>
        </div>
      </div>
    </>
  );
}
